import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';
import { ImageSelector } from '../../../../util/imageSelector/imageSelector';
import { Navbar } from 'ionic-angular/components/toolbar/navbar';

@Component({
  selector: 'page-add-project',
  templateUrl: 'addProject.html',
  providers : [HttpClient, CustomToast]
})
export class AddProjectPage {

  private modalCtrl : ModalController;
  private httpClient : HttpClient;
  private customToast : CustomToast;
  private events : Events;

  private baseUrl;

  private image = {
    id : -1,
    filename : 'addimage.png'
  };

  private users;
  private researchers = [];

  private project = {
    name_es : '',
    name_en : '',
    code : '',
    date_start : '',
    date_end : '',
    funding : '',
    budget : '',
    person_id : '-1',
    coip : '-1',
    text_es : '',
    text_en : '',
    image : '',
    participants : [],
    externalIp : '',
    externalParticipants : '',
    url: ''
  };
  
  @ViewChild(Navbar) navBar : Navbar;

  private participants = [];

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

	constructor(
    private alertController : AlertController,
    public navCtrl: NavController, 
    public navParams: NavParams, 
    httpClient : HttpClient,
    customToast : CustomToast,
    modalCtrl : ModalController, 
    events : Events) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();

    this.customToast = customToast;
    this.events = events;

    this.httpCallPeople();
  }
  ionViewDidLoad() {
    this.navBar.backButtonClick = (e:UIEvent)=>{
     let alert = this.alertController.create({
      title : '¿Seguro que deseas salir?',
      message : 'Los datos no guardados se perderán',
      buttons : [
        {
          text : 'Salir',
          handler : () =>{
            this.navCtrl.pop();
          }
        },
        {
          text : 'Cancelar',
          role : 'cancel'
        }
      ]
     });

     alert.present();
    }
  }

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.project.image = image.filename;
      }
    });
  }

  httpCallPeople(){
    this.httpClient.get('/users?max=10000', (error,data)=>{
      let allusers = data.json();
      this.researchers = allusers.filter(function(user){
        return user.person_type_id==5 || user.person_type_id==18 || user.person_type_id==19;
      }).sort((a,b)=>{
        if (a.name.localeCompare(b.name,'es') < 0)
        return -1;
        if (a.name.localeCompare(b.name,'es') > 0)
        return 1;
      return 0;
      });
      this.users = allusers.filter(function(user){
        return user.person_type_id==5 || user.person_type_id==6 || user.person_type_id==7 || user.person_type_id==8 ;
      }).sort((a,b)=>{
        if (a.name.localeCompare(b.name,'es') < 0)
        return -1;
        if (a.name.localeCompare(b.name,'es') > 0)
        return 1;
      return 0;
      });
    });
  }

  httpPostProject(){
    this.project.participants = this.participants;
    console.log(this.project.participants)
    console.log(this.project)
    this.saveProject();
  }

  private saveProject(){
    if(this.project.url.length && !this.project.url.includes('http')) this.project.url = 'http://' + this.project.url;

    if(!this.project.date_start || !this.project.date_end || !this.project.name_es ||
       ! this.project.funding || !this.project.code || !this.project.budget || !this.project.text_es ){
      this.customToast.showMessage('Asegúrate de haber introducido todos los campos requeridos, incluida la url',2000);

    }if(this.project.person_id === "-1"){
      this.customToast.showMessage('Selecciona un investigador principal',2000);
    }
    else{
      console.log("estoy aquí")
      this.httpClient.post('/projects',this.project,(error,data)=>{
        if(!error){
          this.customToast.showMessage('Proyecto creado correctamente',2000);
          this.navCtrl.pop();
          this.events.publish('addProject:done');
        }
      }); 
    }
  }

  onClickSave(){
    console.log("hola")
    this.httpPostProject();
  }



}



// WEBPACK FOOTER //
// ./src/pages/dashboard/projects/addProject/addProject.ts